import api from "./api";
import { mensagemErro } from "./acesso";

export async function baixarArquivo(url, nomeArquivo, params) {
    try {
        const response = await api.get(url, {
            params,
            responseType: "blob",
        });
        const href = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", nomeArquivo);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
    } catch (erro) {
        let mensagem = "Não foi possível baixar o arquivo";
        const data = erro?.response?.data;
        if (data instanceof Blob) {
            try {
                const texto = await data.text();
                const json = JSON.parse(texto);
                if (json.message) mensagem = json.message;
            } catch (e) {
                mensagem = mensagemErro(erro, mensagem);
            }
        } else {
            mensagem = mensagemErro(erro, mensagem);
        }
        throw new Error(mensagem);
    }
}
